import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryStoreSharedFavoritesData =
  Offers.Responses.GetStoreHotelsWithOffers;

interface UseQueryStoreSharedFavoritesOptions {
  enabled?: boolean;
  initialData?: UseQueryStoreSharedFavoritesData;
}

interface UseQueryStoreSharedFavoritesParameters {
  favoriteIds: string;
}

const useQueryStoreSharedFavorites = (
  parameters: UseQueryStoreSharedFavoritesParameters,
  { enabled = true, initialData }: UseQueryStoreSharedFavoritesOptions,
) => {
  const locale = getLocale();

  const query = useQuery<UseQueryStoreSharedFavoritesData>(
    [QueryId.STORE_SHARED_FAVORITES, parameters, locale],
    async () => {
      const baseUrl = '/api/favorites/share/store-hotels-with-offers';

      const fetchResponse = await fetch(baseUrl, {
        body: JSON.stringify({
          favoriteIds: parameters.favoriteIds,
        }),
        headers: {
          ['Accept-Language']: getCulture(locale),
          ['Content-Type']: 'application/json',
        },
        method: 'POST',
      })
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryStoreSharedFavorites', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryStoreSharedFavorites;
